import HeaderBlog from "@/ui_app/components/header/HeaderBlog.vue";
export default {
    setup: function () {
    },
    components: { HeaderBlog: HeaderBlog }
};
